import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {Permission} from '../../../models/security/permission';
import {PermissionService} from '../../../service/security/service-permission';
import {PermissionCodeService} from '../../../service/security/service-permissioncode';
import {PermissionCode} from '../../../models/security/permissioncode';
import {PermissionsComponent} from './permission.component';
import {GroupPermissionService} from '../../../service/security/service-grouppermission';
import {Staffs} from '../../../models/staff/staffs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {GroupStaffsService} from '../../../service/staff/service-groupstaffs';
import {GroupSelectComponent} from '../group/groupselect.component';

@Component({
  templateUrl: './st.component.html'

})
export class DSStaffsPermissionsComponent implements OnInit, AfterViewInit {
  public language = language;
  public groupId: number= 0;
  public onClose: Subject<boolean>;
  public dataList: Staffs []=[];
  public staffSelectList: Object[];
  public selectedList: Object[];

  constructor(public toastr: ToastrService,
              public _bsModalRef: BsModalRef,
              public staffsService: StaffsService,
              public bsModalService: BsModalService,
              public groupStaffsService: GroupStaffsService
  ) {
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.staffSelectList = [];
    this.selectedList = [];

  }
  public permision(id: number): void {
    const modalEdit = this.bsModalService.show(PermissionsComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<PermissionsComponent>modalEdit.content).showPermision(
      id

    );
    (<PermissionsComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.show(this.groupId);

      }
    });
  }
  public showStaffs()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSelectList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {


      for(let i=0; i< result.length;i++)
      {
        if(this.staffSelectList.some(e => e["id"] === result[i].id)==false) {
          this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
          this.selectedList= [...this.selectedList, result[i].id];
        }
      }
      if(this.selectedList.length> 0)
      {
        this.groupStaffsService.insertMulti(this.groupId, this.selectedList.join()).subscribe({
            next: () => {
              this.toastr.success(language.message_group_staff_success, language.message);
              this.show(this.groupId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  public deleteItem(id: number)
  {
    this.groupStaffsService.deleteByGroupAndStaff(this.groupId, id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.show(this.groupId);
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  public show(id: number): void {
    this.groupId=id;
    this.staffsService.findAllByGroupId(id).subscribe(data=> this.dataList= data);


  }
  public onSelect(): void {

    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

  public nodeChecked(args): void {

  }

}
